module.exports = __webpack_public_path__ + "static/media/WIN_20191203_17_42_10_Pro.jpg:Zone.a4e05036.Identifier";